import * as api from 'api/campaigns'
export const START_ROUNDUPS =  'START_ROUNDUPS'
export const STOP_ROUNDUPS =  'STOP_ROUNDUPS'
export const START_TITHING =  'START_TITHING'
export const STOP_TITHING =  'STOP_TITHING'

export const startRoundups = (userId, campaignId) => ({
  type: START_ROUNDUPS,
  payload: api.startRoundups(userId, campaignId),
})

export const stopRoundups = (userId, campaignId) => ({
  type: STOP_ROUNDUPS,
  payload: api.stopRoundups(userId, campaignId),
})

export const startTithing = (userId, campaignId) => ({
  type: START_TITHING,
  payload: api.startTithing(userId, campaignId),
})

export const stopTithing = (userId, campaignId) => ({
  type: STOP_TITHING,
  payload: api.stopTithing(userId, campaignId),
})
